<template>
  <div id="box-item" :class="{ deleted: box.box_deleted }" ref="card">
    <basic-card class="card">
      <div class="card-content-wrapper">
        <div class="title kaushan-font">
          {{ box.code }}
          <div class="divider"></div>
          <div class="edit-button" @click="editBox">
            <img v-if="!box.box_deleted" src="/static/icons/edit.svg" />
            <img v-else src="/static/icons/edit-white.svg" />
          </div>
          <div class="show-button" @click="showBoxInfo">
            <img
              v-if="!box.box_deleted"
              src="/static/icons/open-eye-icon.svg"
            />
            <img v-else src="/static/icons/open-eye-icon-white.svg" />
          </div>
        </div>
        <div class="content-part">
          <div class="img-part">
            <img
              :src="
                `/static/icons/boxes/${$variables.boxTypes[box.type]}_box.svg`
              "
            />
          </div>
          <div class="info-part">
            <div class="status-wrapper row">
              <div :class="'position-wrapper'">
                <arrow-icon
                  class="position-icon"
                  :movingType="movingType"
                  v-if="movingType !== undefined && movingType !== 0"
                />
                <img
                  class="position-icon"
                  src="/static/icons/atStore-icon.svg"
                  v-else-if="movingType !== undefined && movingType === 0"
                />
                <div
                  :class="`position-image type-${currentLocation}`"
                  v-else
                ></div>
              </div>
              <div class="position">
                <div class="has-partner" v-if="movingType !== undefined">
                  <div v-if="movingType !== 0">
                    {{ box.partnerName }}
                  </div>
                  <div v-if="movingType === 0">
                    {{ $t($variables.locationTypes[0]) }}
                  </div>
                  <div>{{ box.date }}</div>
                </div>
                <div class="no-partner" v-else>
                  {{ $t($variables.locationTypes[currentLocation]) }}
                </div>
              </div>
              <div class="with-keyboard-wrapper">
                <div
                  class="with-keyboard col"
                  v-if="box.withKeyBoard === 1 && box.isMobile == 1"
                >
                  <!-- v-if="location && location.withKeyBoard === 1" -->
                  <img src="/static/icons/keyboard.svg" />
                </div>
              </div>
              <div class="user-image" v-if="movingType !== undefined">
                <avatar
                  :text="box.movementCreatorName"
                  :size="'30px'"
                  :fontSize="'12px'"
                />
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="footer-part" ref="footer" @click.stop>

          <rounded-button
            width="35%"
            height="30px"
            :position="'right'"
            @click="changeQR"
          >
            {{ $t("storeScreen.boxItem.button.qrChange") }}
          </rounded-button>
        </div> -->
      </div>
    </basic-card>
  </div>
</template>

<script>
import BoxModal from "@/components/modules/Boxes/BoxModal";
// import DeleteModal from "@/components/shared/Modals/DeleteModal";
import ConfirmationModal from "@/components/shared/Modals/ConfirmationModal";
import { mapActions } from "vuex";
import BoxOverlay from "./BoxOverlay.vue";
export default {
  name: "BoxItem",
  props: {
    box: {
      type: Object,
      required: true
    },
    value: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  data: () => ({
    opened: undefined
  }),
  mounted() {
    this.opened = this.value;
    // this.showButtons();
  },
  watch: {
    value() {
      this.opened = this.value;
      // this.showButtons();
    }
  },
  computed: {
    location() {
      return this.box.current_position;
    },
    currentLocation() {
      if (!this.box.moved) {
        return 3;
      }
      const currentLocation = this.box.moved;
      if (currentLocation === 0) {
        return 0;
      } else if (currentLocation === 1) {
        return 1;
      } else if (currentLocation === 2) {
        return 2;
      }
      return 3;
    },
    movingType() {
      const currentLocation = this.box.moved;
      if (currentLocation != null) {
        return currentLocation === 1
          ? "from"
          : currentLocation === 2
          ? "to"
          : 0;
      }
      return undefined;
    }
  },
  methods: {
    ...mapActions({
      changeQRNumber: "boxes/changeQRNumber",
      deleteBox: "boxes/deleteBox"
    }),
    changeQR() {
      this.$eventBus.showModal({
        title: this.$t("storeScreen.boxItem.confirmationModal.title"),
        bind: {
          is: ConfirmationModal,
          width: "500px",
          text: this.$t("storeScreen.boxItem.confirmationModal.text", {
            code: this.box.code,
            qrNumber: this.box.QRNumber
          })
        },
        on: {
          okClicked: () => {
            this.$eventBus.closeModal();
            this.changeQRNumberAction();
          }
        }
      });
    },
    changeQRNumberAction() {
      this.changeQRNumber({ id: this.box.box_id })
        .then(res => {
          if (res.status === "OK") {
            this.$emit("refreshData");
            this.$notification.showNoti("success", "boxItem.changeQR.success");
          } else {
            this.$notification.showNoti("error", null, res);
          }
        })
        .catch(() =>
          this.$notification.showNoti("error", "boxItem.changeQR.success")
        );
    },
    // arhiveBox() {
    //   this.$eventBus.showModal({
    //     title: this.$t("storeScreen.boxItem.deleteModal.title"),
    //     bind: {
    //       is: DeleteModal,
    //       width: "500px",
    //       text: this.$t("storeScreen.boxItem.deleteModal.text", {
    //         code: this.box.code,
    //         qrNumber: this.box.QRNumber
    //       })
    //     },
    //     on: {
    //       deleteClicked: () => {
    //         this.$eventBus.closeModal();
    //         this.deleteAction();
    //       }
    //     }
    //   });
    // },
    // deleteAction() {
    //   this.deleteBox({ id: this.box.id })
    //     .then(res => {
    //       if (res.status === "OK") {
    //         this.$emit("refreshData");
    //         this.$notification.showNoti("success", "boxItem.delete.success");
    //       } else {
    //         this.$notification.showNoti("error", null, res);
    //       }
    //     })
    //     .catch(() =>
    //       this.$notification.showNoti("error", "boxItem.delete.success")
    //     );
    // },
    showBoxInfo() {
      this.$eventBus.showOverlay({
        bind: {
          is: BoxOverlay,
          box: this.box
        },
        title: this.$t("storeScreen.boxItem.info.overlay", {
          boxCode: this.box.code
        })
      });
    },
    editBox() {
      this.$eventBus.showModal({
        title: this.$t("storeScreen.boxModal.update.title"),
        bind: {
          is: BoxModal,
          width: "400px",
          height: "380px",
          box: this.box
        },
        on: {
          refreshData: () => {
            this.$emit("refreshData");
          }
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/styles/variables.scss";
#box-item {
  width: 100%;
  // height: 105px;
  height: 100%;
  &.deleted {
    color: white;
    // border-color: #000000;
    .card {
      background: firebrick;
      border-color: firebrick;
    }
  }
  .card {
    position: relative;
    // cursor: pointer;
    height: 100%;
    width: 100%;
    padding: 5px !important;
    margin: auto;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    .card-content-wrapper {
      .title {
        width: 100%;
        text-align: center;
        font-size: 18px;
        .edit-button {
          position: absolute;
          top: 0;
          right: 0;
          width: 40px;
          height: 32px;
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;
          border-radius: 10px;
          &:hover {
            background: rgba(0, 0, 0, 0.1);
          }
          img {
            height: 20px;
            width: 20px;
          }
        }
        .show-button {
          position: absolute;
          top: 0;
          left: 0;
          width: 40px;
          height: 32px;
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;
          border-radius: 10px;
          &:hover {
            background: rgba(0, 0, 0, 0.1);
          }
          img {
            height: 20px;
            width: 20px;
          }
        }
      }
      .content-part {
        display: flex;
        flex-direction: row;
        margin-top: 10px;
        .img-part {
          width: 55px;
          display: flex;
          justify-content: center;
          align-items: center;
          margin-right: 10px;
          img {
            width: 50px;
          }
        }
        .info-part {
          width: 100%;
          .status-wrapper {
            .user-image {
              // margin-left: auto;
              margin-right: 0;
              justify-content: center;
              align-items: center;
              display: flex;
            }
            .with-keyboard-wrapper {
              margin-right: 5px;
              margin-left: auto;
              justify-content: center;
              align-items: center;
              display: flex;
              .with-keyboard {
                height: 30px;
                width: 30px;
                background: aliceblue;
                border-radius: 50%;
                padding: 3px;
                border: 1px solid $color-primary;
                img {
                  width: 90%;
                }
              }
            }
            .position {
              font-weight: 550;
              font-size: 13px;
              margin-bottom: 2px;
              .has-partner {
                div {
                  margin-bottom: 5px;
                }
              }
            }
            .position-wrapper {
              justify-content: center;
              align-items: center;
              display: flex;
              margin-right: 5px;
              .position-icon {
                width: 20px;
                height: 20px;
              }
              .position-image {
                height: 12px;
                width: 12px;
                border-radius: 50%;
                border: 1px solid $color-primary;
              }
            }
          }
          .row {
            display: flex;
            .text {
              font-size: 14px;
              word-break: break-word;
            }
            // .text {
            //   font-size: 15px;
            //   margin-left: 5px;
            //   font-weight: 550;
            // }
          }
        }
      }
      .footer-part {
        display: flex;
        margin-top: 15px;
      }
    }
  }
}
</style>
